// // import React, { useEffect, useState } from "react";
// // import { Navigate } from "react-router-dom";
// // import { validateToken } from "./validateToken.js";
// // import { getCookie } from "./webStorage.js";
// // import { useUser } from "./userProvider.js";
// // import {  SuwasthiLoader } from "../components/loader.js";
// // import { hasAnyPermission } from "./permissions.js";

// // const ProtectedRoute = ({ children, resource, actions }) => {
// //   const { setUser, permissions, } = useUser();
// //   const [isValidated, setIsValidated] = useState(false);
// //   const [loading, setLoading] = useState(true);

// //   console.log("protected route permissions", children,resource, actions);

// //   useEffect(() => {
// //     const token = getCookie("SWFMSToken");
// //     if (!token) {
// //       window.location.href = "/";
// //       return;
// //     }

// //     validateToken(token)
// //       .then((user) => {
// //         if (user?.success) {

// //           console.log("🛂 User Data from API:", user.data);
// //           console.log("🔑 Permissions from API:", user.data.permissions);
          
// //           setUser(user.data);
// //           setIsValidated(true);
          
// //         } else {
// //           setIsValidated(false);
// //         }
// //       })
// //       .catch((error) => {
// //         console.error("Token validation failed:", error);
// //         setIsValidated(false);
// //       })
// //       .finally(() => {
// //         setLoading(false);
// //       });
// //   }, []);

// //   if (loading) {
// //     return <SuwasthiLoader maintext="Verifying.." />;
// //   }

// //   if (!isValidated) {
// //     return <Navigate to="/" />;
// //   }

// //   // 🚀 Check if user has at least one required permission
// //   if (!hasAnyPermission(permissions, resource, actions)) {
// //     return <Navigate to="/unauthorized" />;
// //   }

// //   return children;
// // };

// // export default ProtectedRoute;




// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { validateToken } from "./validateToken.js";
// import { getCookie } from "./webStorage.js";
// import { useUser } from "./userProvider.js";
// import {  SuwasthiLoader } from "../components/loader.js";
// import { hasAnyPermission } from "./permissions.js";

// const ProtectedRoute = ({ children, resource, actions }) => {
//   const { setUser, permissions, } = useUser();
//   const [isValidated, setIsValidated] = useState(false);
//   const [loading, setLoading] = useState(true);

//   console.log("protected route permissions", children,resource, actions);

// useEffect(() => {
//   const token = getCookie("SWFMSToken");
//   if (!token) {
//     window.location.href = "/";
//     return;
//   }

//   validateToken(token)
//     .then((user) => {
//       if (user?.success) {
//         console.log("🛂 User Data from API:", user.data);
//         console.log("🔑 Permissions from API:", user.data.permissions);
        
//         setUser(user.data);
//         setIsValidated(true);
//       } else {
//         setIsValidated(false);
//       }
//     })
//     .catch((error) => {
//       console.error("Token validation failed:", error);
//       setIsValidated(false);
//     })
//     .finally(() => {
//       setLoading(false);
//     });
// }, [setUser]); // ✅ added setUser here

//   if (loading) {
//     return <SuwasthiLoader maintext="Verifying.." />;
//   }

//   if (!isValidated) {
//     return <Navigate to="/" />;
//   }

//   // 🚀 Check if user has at least one required permission
//   if (!hasAnyPermission(permissions, resource, actions)) {
//     return <Navigate to="/unauthorized" />;
//   }

//   return children;
// };

// export default ProtectedRoute;

import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { validateToken } from "./validateToken.js";
import { getCookie } from "./webStorage.js";
import { useUser } from "./userProvider.js";
import { SuwasthiLoader } from "../components/loader.js";
import { hasAnyPermission } from "./permissions.js";

const ProtectedRoute = ({ children, resource, actions }) => {
  const {  setUser, permissions } = useUser();
  const [status, setStatus] = useState({
    loading: true,
    isValidated: false,
  });

  useEffect(() => {
    const token = getCookie("SWFMSToken");
    if (!token) {
      window.location.href = "/";
      return;
    }

    validateToken(token)
      .then((res) => {
        if (res?.success) {
          console.log("🛂 User Data from API:", res.data);
          console.log("🔑 Permissions from API:", res.data.permissions);

          setUser(res.data);

          // update status state
          setStatus({ loading: false, isValidated: true });
        } else {
          setStatus({ loading: false, isValidated: false });
        }
      })
      .catch((error) => {
        console.error("Token validation failed:", error);
        setStatus({ loading: false, isValidated: false });
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // ✅ Ignore the warning safely

  if (status.loading) {
    return <SuwasthiLoader maintext="Verifying..." />;
  }

  if (!status.isValidated) {
    return <Navigate to="/" replace />;
  }

  if (!permissions) {
    return <SuwasthiLoader maintext="Checking permissions..." />;
  }

  if (!hasAnyPermission(permissions, resource, actions)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
